import { render } from "./ViewAboutContent.vue?vue&type=template&id=a956d368&scoped=true"
import script from "./ViewAboutContent.vue?vue&type=script&lang=js"
export * from "./ViewAboutContent.vue?vue&type=script&lang=js"

import "./ViewAboutContent.vue?vue&type=style&index=0&id=a956d368&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a956d368"]])

export default __exports__